const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const serializeCsvValue = (value) => {
  if (value == null) return '';
  const str = typeof value === 'string' ? value : JSON.stringify(value);
  const escaped = str.replace(/"/g, '""');
  return `"${escaped}"`;
};

export const downloadResumeJson = (resume, filename = 'resume.json') => {
  const blob = new Blob([JSON.stringify(resume, null, 2)], { type: 'application/json' });
  downloadBlob(blob, filename);
};

export const downloadResumeCsv = (resume, filename = 'resume.csv') => {
  const data = resume || {};
  const keys = Object.keys(data);
  const header = keys.map(serializeCsvValue).join(',');
  const row = keys.map((key) => serializeCsvValue(data[key])).join(',');
  const csv = `${header}\n${row}\n`;
  const blob = new Blob([csv], { type: 'text/csv' });
  downloadBlob(blob, filename);
};
